export const IdProdutoImgMap: {
    id: number,
    img: string,
    url?: string
}[] = [
        {
          id: 9,
          img: '/logo_auto_veles.png',
          url: '/auto-veles'
        },
        {
            id: 5,
            img: '/logo_dash_veles.png',
            url: '/dashboard'
        },
        {
            id: 6,
            img: '/logo_geo_veles.png',
            url: '/geo-veles'
        },
        {
          id: 3,
          img: '/logo_ia_veles.png',
          url: '/ia-veles'
        },
        {
          id: 1,
          img: '/logo_id_veles.png',
          url: '/id-veles'
        },
        {
          id: 8,
          img: '/logo_mkt_veles.png',
          url: '/mkt-veles'
        }
    ]